import BottomNav from "../components/BottomNav";
import { useNavigate } from "react-router-dom";
import "../css/FundsScreen.css";
import "../css/mainhome.css";
import { useEffect, useMemo, useState } from "react";
import AppHeader from "../components/AppHeader";
import apiClient from "../api/apiClient";
import {
  getWithdrawTimingMessage,
  isWithinWithdrawTime,
  readStoredFeeSettings,
} from "../utils/withdrawSettings";

/* ✅ React Icons */
import { FaPlus, FaHistory, FaUniversity } from "react-icons/fa";
import { MdOutlinePendingActions, MdAccountBalanceWallet } from "react-icons/md";
import { GiTakeMyMoney } from "react-icons/gi";

export default function FundsScreen() {
  const navigate = useNavigate();
  const walletBalance = localStorage.getItem("walletBalance");
  const [feeSettings, setFeeSettings] = useState(() => readStoredFeeSettings());
  const [withdrawNoticeVisible, setWithdrawNoticeVisible] = useState(false);

  useEffect(() => {
    const fetchFeeSettings = async () => {
      try {
        const mobileNo = localStorage.getItem("mobileNo");

        const response = await apiClient.get("/fees-settings", {
          params: { mobileNo },
        });

        const { status, info } = response.data;
        if (status === true) {
          localStorage.setItem("feeSettings", JSON.stringify(info));
          setFeeSettings(info);
        }
      } catch (err) {
        console.error("Error fetching fee settings:", err);
      }
    };

    fetchFeeSettings();
  }, []);

  const withdrawStatus = useMemo(() => {
    const isOpen = isWithinWithdrawTime(feeSettings);
    const timingText = getWithdrawTimingMessage(feeSettings);

    return {
      isOpen,
      title: isOpen ? "Withdrawal Open" : "Withdrawal Closed",
      message: timingText,
    };
  }, [feeSettings]);

  const handleWithdrawClick = () => {
    try {
      if (withdrawStatus.isOpen) {
        navigate("/funds/withdraw");
      } else {
        setWithdrawNoticeVisible(true);
      }
    } catch (error) {
      console.error("Error during withdrawal check:", error);
      setWithdrawNoticeVisible(true);
    }
  };

  /* ✅ ICONS UPDATED */
  const tiles = [
    {
      icon: <FaPlus />,
      title: "Add Funds",
      tone: "peach",
      onClick: () => navigate("/funds/add"),
    },
    {
      icon: <MdOutlinePendingActions />,
      title: "Manual Deposit Requests",
      tone: "peach2",
      onClick: () => navigate("/funds/depositHistory"),
    },
    {
      icon: <FaHistory />,
      title: "Withdraw History",
      tone: "lavender",
      onClick: () => navigate("/funds/WithdrawHistory"),
    },
    {
      icon: <FaUniversity />,
      title: "Add Bank Details",
      tone: "teal",
      onClick: () => navigate("/funds/addBankDetails"),
    },
    {
      icon: <GiTakeMyMoney />,
      title: "Withdraw Funds",
      tone: "blue",
      meta: withdrawStatus.message,
      disabledReason: withdrawStatus.isOpen ? "" : withdrawStatus.title,
      onClick: handleWithdrawClick,
    },
    {
      icon: <MdAccountBalanceWallet />,
      title: "Account Statement",
      tone: "green",
      onClick: () => navigate("/passbook"),
    },
  ];

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title="Funds"
        walletBalance={walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate("/passbook")}
      />

      <div className="funds-grid square">
        {tiles.map((t) => (
          <button
            key={t.title}
            className={`funds-tile tone-${t.tone} ${t.disabledReason ? "funds-tile-muted" : ""} ${withdrawNoticeVisible && t.title === "Withdraw Funds" ? "show-inline-notice" : ""}`}
            onClick={t.onClick}
          >
            <div className="tile-icon-wrap">
              {t.icon}
            </div>

            <div className="tile-content">
              <div className="tile-title">{t.title}</div>
              {t.meta && <div className="tile-meta">{t.meta}</div>}
              {withdrawNoticeVisible && t.title === "Withdraw Funds" && t.disabledReason && (
                <div className="tile-inline-notice">
                  {t.disabledReason}. {t.meta}
                </div>
              )}
            </div>
            <span className="tile-accent" />
          </button>
        ))}
      </div>

      <BottomNav active="Funds" />
    </div>
  );
}
